(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mailsac-v2", [], factory);
	else if(typeof exports === 'object')
		exports["mailsac-v2"] = factory();
	else
		root["mailsac-v2"] = factory();
})(global, function() {
return 